<template>
  <v-ons-page class="ja-template-select page">
    <common-header>
      <template #header>
        <span>テンプレートを選択する</span>
      </template>
    </common-header>

    <div class="select-button-area">
      <!-- 横型 -->
      <template v-if="isHorizontalDisplay">
        <div v-for="TEMPLATE in HORIZONTAL_TEMPLATES" :key="TEMPLATE.ID">
          <large-button
            :class="['large-button', { 'border-green': TEMPLATE.ID === templateId }]"
            @click="selectTemplate(TEMPLATE.ID)"
            :title="TEMPLATE.TITLE"
            :description="TEMPLATE.DESCRIPTION"
            :image="TEMPLATE.IMAGE"
            :alt="TEMPLATE.ALT"
          />
        </div>
      </template>
      <!-- 縦型 -->
      <template v-else>
        <div v-for="TEMPLATE in VERTICAL_TEMPLATES" :key="TEMPLATE.ID">
          <large-button
            :class="['large-button', { 'border-green': TEMPLATE.ID === templateId }]"
            @click="selectTemplate(TEMPLATE.ID)"
            :title="TEMPLATE.TITLE"
            :description="TEMPLATE.DESCRIPTION"
            :image="TEMPLATE.IMAGE"
            :alt="TEMPLATE.ALT"
          />
        </div>
      </template>
    </div>

    <common-footer class="common-footer d-flex">
      <template #footer>
        <v-ons-row class="footer-button-area">
          <small-button
            class="footer-back-button"
            title="戻る"
            :disabled="false"
            @click="() => moveBackButton(router)"
          />
          <small-button
            class="footer-next-button"
            title="次へ"
            :disabled="isNextButtonDisable"
            @click="moveMaterialSelect"
          />
        </v-ons-row>
      </template>
    </common-footer>
  </v-ons-page>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import LargeButton from '@/components/common/LargeButton.vue';
import CommonHeader from '@/components/common/CommonHeader.vue';
import CommonFooter from '@/components/common/CommonFooter.vue';
import SmallButton from '@/components/common/SmallButton.vue';
import { fetchUserInformation } from '@/composable/data_fetch_common';
import { moveBackButton } from '@/composable/common';
import {
  CONTENT_CAPTION_COLOR,
  NONE_FRAME_BOTTOM,
  HORIZONTAL_TEMPLATES,
  VERTICAL_TEMPLATES,
} from '@/composable/constant_common';

// 「次へ」ボタン無効フラグ
const isNextButtonDisable = ref(true);
// 横型ディスプレイフラグ
const isHorizontalDisplay = ref(1);
// テンプレートID
const templateId = ref(0);

// store, router
const store = useStore();
const router = useRouter();

// lifecycle
onMounted(async () => {
  // プレビュー表示用コンテンツデータの初期化
  store.commit('content/setTemplateId', '');
  store.commit('content/setMaterialIdList', []);
  store.commit('content/setContentMaterialList', []);
  store.commit('content/setContentCaption', '');
  store.commit('content/setContentCaptionColor', CONTENT_CAPTION_COLOR.white);
  store.commit('content/setContentFrame', NONE_FRAME_BOTTOM);

  // ユーザ情報最新化
  const userInformation = await fetchUserInformation();
  store.commit('userInformation/setUserName', userInformation.userName);
  store.commit('userInformation/setIsHorizontalDisplay', userInformation.isHorizontalDisplay);

  // 横型ディスプレイフラグ取得
  isHorizontalDisplay.value = userInformation.isHorizontalDisplay;
});

/**
 * テンプレート選択処理
 */
const selectTemplate = (selectedId) => {
  templateId.value = selectedId;
  store.commit('content/setTemplateId', selectedId);
  isNextButtonDisable.value = false;
};
/**
 * 素材選択画面遷移処理
 */
const moveMaterialSelect = () => {
  router.push('/ja/content/materialSelect');
};
</script>

<style scoped>
.ja-template-select {
  margin: auto;
}
.select-button-area {
  background-color: #fff;
  margin: auto;
  height: 100%;
  padding-top: 10vh;
  padding-top: 10dvh;
  padding-bottom: 10vh;
  padding-bottom: 10dvh;
  z-index: 1;
}
.large-button {
  width: 90%;
  margin: auto;
}
.large-button:hover,
.footer-back-button:hover,
.footer-next-button:hover {
  opacity: 0.8;
}
.large-button :deep(.button) {
  margin-bottom: 1.5rem;
  width: 100%;
}
.large-button :deep(.image) {
  padding: 2rem;
}
.border-green :deep(.button) {
  border: 0.5rem #21963b solid;
}
.border-green :deep(.button:active) {
  background-color: #fff;
}
.footer-button-area {
  height: 100%;
  width: 90%;
}
.footer-back-button {
  background: #fff;
  border: solid 1px #cccccc;
  color: #222222;
  margin: auto;
  padding: 1rem 0;
  text-align: center;
  width: 25%;
}
.footer-next-button {
  box-shadow: 0rem 0.2rem #21963b;
  color: #fff;
  margin: auto;
  padding: 1rem 0;
  text-align: center;
  width: 65%;
}
.common-footer {
  height: auto;
  padding-block: 2rem;
}
</style>
